import AuthPagesMixins from "@/mixins/auth.pages.mixins";
import AuthValidationMixin from "@/mixins/auth.validation.mixin";
import MobileViewDetectorMixin from "@/mixins/mobile.view.detector.mixin";
import { Mixins } from "vue-property-decorator";

export default abstract class AuthBaseVue extends Mixins<AuthPagesMixins>(MobileViewDetectorMixin, AuthValidationMixin) {
    
} 